import { IHeadingStyle } from '../models/index.js';
export const headingStyle: IHeadingStyle = {
	position: 'relative',
	width: '100%',
};
